import React from 'react';

const TextError = (props) => {
  return <div className='error-message'>{props.children}</div>;
};

export default TextError;
